import { render, staticRenderFns } from "./horasprojetoscompetencia.vue?vue&type=template&id=50da403e&"
import script from "./horasprojetoscompetencia.vue?vue&type=script&lang=js&"
export * from "./horasprojetoscompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports